var map = {
	"./slider1.jpeg": 427,
	"./slider10.jpeg": 963,
	"./slider11.jpeg": 692,
	"./slider2.jpeg": 525,
	"./slider3.jpeg": 55,
	"./slider4.jpeg": 435,
	"./slider5.jpeg": 793,
	"./slider6.jpeg": 597,
	"./slider7.jpeg": 554,
	"./slider8.jpeg": 150,
	"./slider9.jpeg": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;